import { useEffect, useState } from "react";
import { Form, Modal, Typography } from "antd";

import { createAccessUnit, deleteAccessUnit } from "@/api/requests";

import CustomSelect from "@/components/inputs/CustomSelect";

const { Text } = Typography;

// Окно для редактирования списка рабочих групп заявки, содержит форму
const RequestUnitsModal = ({
  data = {},
  requestUnits = [],
  units = [],
  visible,
  onSave,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        units: requestUnits?.map((u) => u.uuid),
        uuid: data.uuid,
      });

      setError(null);
    }
  }, [visible, requestUnits, data.uuid, form]);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      const currentUnitUuids = requestUnits
        ?.map((u) => u.uuid)
        .filter(Boolean);

      const selectedUnitUuids = values.units || [];

      const currentSet = new Set(currentUnitUuids);
      const selectedSet = new Set(selectedUnitUuids);

      const unitsToAdd = selectedUnitUuids.filter(
        (unitUuid) => !currentSet.has(unitUuid),
      );

      const unitsToDelete = currentUnitUuids.filter(
        (unitUuid) => !selectedSet.has(unitUuid),
      );

      for (const unitUuid of unitsToDelete) {
        const unit = requestUnits?.find((u) => u.uuid === unitUuid)
        await deleteAccessUnit({
          uuid: unit.link_uuid,
        });
      }

      for (const unitUuid of unitsToAdd) {
        await createAccessUnit({
          request_form_uuid: data.uuid,
          unit_uuid: unitUuid,
        });
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then(handleSave)
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title="Редактировать исходные рабочие группы"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item name="units" label="Рабочие группы">
          <CustomSelect
            mode="multiple"
            showSearch
            options={units}
            fieldNames={{ label: "name", value: "uuid" }}
            optionFilterProp="name"
          />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default RequestUnitsModal;
